import { render, staticRenderFns } from "./CompleteRegister.vue?vue&type=template&id=0fc64e59&scoped=true"
import script from "./CompleteRegister.vue?vue&type=script&lang=js"
export * from "./CompleteRegister.vue?vue&type=script&lang=js"
import style0 from "./CompleteRegister.vue?vue&type=style&index=0&id=0fc64e59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc64e59",
  null
  
)

export default component.exports